// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ed6fc407","732":"71369844","977":"a78e8803"}[chunkId] + ".chunk.js";
};